<template>
  <v-form class="py-4">
    <div class='mt-2 d-flex' style="gap: 15px;">
      <v-text-field
        v-model="badge.last"
        @input="$emit('onChange', { last: $event })"
        outlined
        :label="$t('profile.contacts.last_name')"
        class="lfs-text-field lfs-required lfs-mb-20"
        height="50"
      />

      <v-text-field
        v-model="badge.first"
        @input="$emit('onChange', { first: $event })"
        outlined
        :label="$t('profile.contacts.first_name')"
        class="lfs-text-field lfs-required lfs-mb-20"
        height="50"
      />
    </div>

    <div>
      <v-text-field
        v-model="badge.position"
        @input="$emit('onChange', { position: $event })"
        outlined
        :label="$t('profile.company.position')"
        class="lfs-text-field lfs-mb-20"
        height="50"
      />

      <div></div>
    </div>

    <div>
      <v-textarea
        v-model="badge.about"
        @input="$emit('onChange', { about: $event })"
        color='#2c9cdb'
        class='lfs-textarea'
        item-color='#2c9cdb'
        :counter="400"
        maxLength="400"
        :label="$t('profile.about_description')"
      />
    </div>
  </v-form>
</template>

<script>
export default {
  props: ['badge']
}
</script>
